<app-page-heading [key]="'pods-validation.title'"
                  [subheadingIcon]="'fa fa-truck'">
</app-page-heading>

<section class="container-fluid summary-panel space-top-20 pod-container">
    <section class="container-fluid summary-panel pod-list">
        <app-pods-validation-filters [(filters)]="filters"
                                     [disableSearch]="disableSearch()"
                                     [displaySendReminderButton]="!isCarrier && this.lastSearchFilter.carriers.length === 1 && tabResultCount.pendingTotalCount > 0"
                                     [displayExportButton]="tabResultCount.totalCount > 0"
                                     [originOptions]="originOptions"
                                     [isCarrier]="isCarrier"
                                     [allCarriers]="allCarriers"
                                     [availableRegions]="availableRegions"
                                     [availableCarriers]="availableCarriers"
                                     (search)="search()"
                                     (reset)="reset()"
                                     (regionsChange)="regionsChanged($event)"
                                     (carriersChange)="carriersChanged($event)"
                                     (sendReminder)="openConfirmSendPendingReminder(sendPendingReminderModal)"
                                     (export)="openConfirmExportPodsValidation(exportPodsValidationModal)"
        ></app-pods-validation-filters>

        <app-pods-validation-list [(filters)]="filters"
                                  [tabResultCount]="tabResultCount"
                                  [displayedPod]="selectedPod"
                                  [podsValidation]="podsValidation"
                                  [lastPage]="lastPage"
                                  (podSelected)="selectedPod = $event"
                                  (podRejected)="onPodRejected($event)"
                                  (podValidated)="onPodValidated($event)"
                                  (podUploaded)="onPodUploaded($event)"
                                  (appendOriginGlidFilter)="appendOriginGlidFilter($event)"
                                  (appendDestinationGlidFilter)="appendDestinationGlidFilter($event)"
                                  (filtersChange)="onListFiltersChange($event)">
        </app-pods-validation-list>
    </section>

    <section class="container-fluid summary-panel document-preview">
        <app-pods-validation-document [shouldDisplayEmptyPage]="isCarrier && filters.podState === POD_STATE.PENDING"
                                      [canEditProduct]="isPodReviewer"
                                      [selectedPod]="selectedPod">
        </app-pods-validation-document>
    </section>
</section>

<ng-template #exportPodsValidationModal>
    <span [i18n]="[{target: 'innerHTML', key: 'pods-validation.modal.export.body', params: { count: tabResultCount.totalCount }}]"></span>
</ng-template>

<ng-template #sendPendingReminderModal>
    <span [i18n]="[{target: 'innerHTML', key: 'pods-validation.modal.reminder.body', params: { carrierName: getSelectedCarrierName(), count: tabResultCount.pendingTotalCount + tabResultCount.chepReviewTotalCount }}]"></span>
</ng-template>
